const React = require("react");
function IconFlightTakeoff(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.77488 21c-.21667 0-.39583-.0708-.5375-.2125s-.2125-.3208-.2125-.5375.07083-.3958.2125-.5375.32083-.2125.5375-.2125H20.2749c.2166 0 .3958.0708.5375.2125s.2125.3208.2125.5375-.0708.3958-.2125.5375-.3209.2125-.5375.2125zm1.375-5.35c-.16667.05-.32917.0417-.4875-.025s-.27917-.175-.3625-.325l-1.875-3.2c-.11667-.1833-.1375-.3583-.0625-.525s.22083-.2667.4375-.3c.08333-.0167.175-.0083.275.025s.18333.075.25.125l1.525 1.35 5.65002-1.525-3.75002-6.275c-.15-.25-.17917-.49167-.0875-.725s.27917-.39167.5625-.475c.13333-.03333.275-.03333.425 0s.275.09167.375.175l6.77502 6.125 5.4-1.45c.45-.13333.8583-.05417 1.225.2375.3666.29167.55.67917.55 1.1625 0 .3167-.0959.6-.2875.85-.1917.25-.4375.4167-.7375.5z"
  }));
}
module.exports = IconFlightTakeoff;